module.exports = __webpack_public_path__ + "img/電気回路_1_4.ee72bc26.png";